import React, { useEffect, useState } from "react";
import styles from "./RatingScoreComponent.module.scss";
import { InputLabel, TextField, Tooltip } from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SingleRangeComponent from "components/singlerange/SingleRangeComponent";
import { useDispatch } from "react-redux";
import { setWeight } from "redux/slices/scoringSlice";
import { truncateText } from "utils/utils";
import { setPublish } from "redux/slices/globalSlice";

const RatingScoreComponent = ({ handleDelete, item }) => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const handleCheck = (e) => {
    dispatch(setPublish(true))
    setShow(e?.target?.checked);
  };
  // console.log("item_rating", item);
  // const handleRating = (values) => {
  //     console.log('values', values)

  //     // dispatch(setWeight(
  //     //     {
  //     //         type: "field",
  //     //         fieldId: item?.fieldId,
  //     //         scoreType: "byRange",
  //     //         // options: [
  //     //         //     ...options
  //     //         // ]
  //     //     }
  //     // ))

  // }
  // const handleRating = (values) => {
  //     console.log('values', values)
  //     const { ranges, between } = values;
  //     const range = ranges[0];
  //     const transformedRange = {
  //         range: {
  //             lowerBound: {
  //                 option: range.lower,
  //                 score: Number(range.lowerScore)
  //             },
  //             between: between.map(item => {
  //                 const option = `${item.lower}-${item.upper}`;
  //                 return {
  //                     option: option,
  //                     score: Number(item.score)
  //                 };
  //             }),
  //             upperBound: {
  //                 option: range.upper,
  //                 score: Number(range.upperScore)
  //             }
  //         }

  //     };
  //     console.log('transformedRange', transformedRange)
  //     dispatch(setWeight(
  //         {
  //             type: "field",
  //             fieldId: item?.fieldId,
  //             scoreType: "byRange",
  //             range: {
  //                 ...transformedRange.range
  //             },
  //             maxWeight: transformedRange?.range?.upperBound?.score
  //         }

  //     ))

  // };
  useEffect(() => {
    if (item?.scoreType==="byRange") {
      setShow(!show);
    }
  }, [item]);

  return (
    <>
      <div className={styles?.scoreContainer}>
        <div className={styles?.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip title={item?.name}>
              <span>{truncateText(item?.name || "", 50)}</span>
            </Tooltip>
            <Tooltip title={"Assign a value to each choice below."}>
              <InfoOutlinedIcon
                fontSize="small"
                sx={{ color: "#3e9ef7", cursor: "pointer" }}
              />
            </Tooltip>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <input
              type="checkbox"
              onChange={(e) => handleCheck(e)}
              checked={show}
            />{" "}
            Score by Range
            <span
              style={{ cursor: "pointer" }}
              onClick={() => handleDelete(item.id, item?.fieldId)}
            >
              <HighlightOffOutlinedIcon
                sx={{ color: "#3e9ef7" }}
                fontSize="medium"
              />
            </span>
          </div>
        </div>
        {show && (
          <div className={styles?.options}>
            <div>
              <SingleRangeComponent item={item} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RatingScoreComponent;
